import React, { useState } from 'react';
import moment from 'moment';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { updateDentalAppointmentDate } from '../../../services/api/cashless-dentals';

const UpdateAppointmentDateModal = ({
    isOpen,
    closeModal,
    requestId,
    currentDate,
    onSuccess,
}) => {
    const initial = currentDate
        ? moment(currentDate, ['YYYYMMDD', 'YYYY-MM-DD', 'DD MMM, YY']).format('YYYY-MM-DD')
        : '';
    const [date, setDate] = useState(initial);
    const [reason, setReason] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!date) {
            toast.error('Please pick a date');
            return;
        }
        if (!reason.trim()) {
            toast.error('Please enter a reason');
            return;
        }
        const dateKey = moment(date, 'YYYY-MM-DD').format('YYYYMMDD');
        setSubmitting(true);
        try {
            await updateDentalAppointmentDate({
                requestId,
                dateKey,
                reason: reason.trim(),
            });
            toast.success('Appointment date updated');
            if (onSuccess) onSuccess();
            closeModal();
        } catch (err) {
            const msg = err?.response?.data?.errorMessage
                || err?.response?.data?.message
                || err?.message
                || 'Failed to update appointment date';
            toast.error(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={closeModal}>
            <ModalHeader className="bg-primary" toggle={closeModal}>
                Edit Appointment Date (Request Id: {requestId})
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="updateApptDate">New Date</Label>
                    <Input
                        id="updateApptDate"
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="updateApptReason">Reason</Label>
                    <Input
                        id="updateApptReason"
                        type="textarea"
                        rows={3}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Why is this date being corrected?"
                    />
                </FormGroup>
                <div style={{ fontSize: '0.8rem', color: '#888' }}>
                    This is a data correction. Status, slot, and center will remain unchanged.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="info" onClick={handleSubmit} disabled={submitting}>
                    {submitting ? 'Saving…' : 'Save'}
                </Button>
                <Button color="secondary" onClick={closeModal} disabled={submitting}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default UpdateAppointmentDateModal;
